import { parsePhoneNumberFromString } from 'libphonenumber-js/max'
import api from '@/components/tools/api'

export function normalizePhone (rawPhone, defaultCountry = 'DE') {
  const phone = parsePhoneNumberFromString(rawPhone, defaultCountry)

  if (!phone || !phone.isValid()) {
    return null
  }
  // console.log('normalized phone', phone, phone.getType())

  return {
    e164: phone.number,
    type: phone.getType(),
    isMobile:
      phone.getType() === 'MOBILE' ||
      phone.getType() === 'FIXED_LINE_OR_MOBILE'
  }
}

function formatDateMini (date) {
  if (typeof date === 'string') {
    date = Date.parse(date)
  }

  return new Date(date).toLocaleString('en-GB', {
    year: 'numeric',
    month: '2-digit'
  })
}

function formatDate (date, locale = 'de-DE') {
  if (!date) {
    return null
  }
  if (typeof date === 'string') {
    date = Date.parse(date)
  }

  return new Date(date).toLocaleString(locale, {
    hour: 'numeric',
    minute: 'numeric',
    weekday: 'short',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    timeZone: 'CET'
  })
}

function formatDateWithSeconds (date, locale = 'de-DE') {
  if (!date) {
    return null
  }
  if (typeof date === 'string') {
    date = Date.parse(date)
  }

  return new Date(date).toLocaleString(locale, {
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    weekday: 'short',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    timeZone: 'CET'
  })
}

function formatDateLong (date, locale = 'de-DE') {
  if (!date) {
    return null
  }
  if (typeof date === 'string') {
    date = Date.parse(date)
  }

  return new Date(date).toLocaleString(locale, {
    hour: 'numeric',
    minute: 'numeric',
    weekday: 'long',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    timeZone: 'CET'
  })
}

function formatDateWithoutTimeShort (date, locale = 'de-DE') {
  if (!date) {
    return null
  }
  if (typeof date === 'string') {
    date = Date.parse(date)
  }

  return new Date(date).toLocaleString('de-DE', {
    weekday: 'short',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    timeZone: 'CET'
  })
}

function formatDateAvailabilty (date, locale = 'de-DE') {
  if (!date) {
    return null
  }
  if (typeof date === 'string') {
    date = Date.parse(date)
  }

  return new Date(date).toLocaleString(locale, {
    weekday: 'long',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    timeZone: 'CET'
  })
}

function formatDateShort (date) {
  if (typeof date === 'string') {
    date = Date.parse(date)
  }

  return new Date(date).toLocaleString('de-DE', {
    hour: 'numeric',
    minute: 'numeric',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    timeZone: 'CET'
  })
}

function formatDateMonthYear (date) {
  if (typeof date === 'string') {
    date = Date.parse(date)
  }
  return new Date(date).toLocaleString('en-EN', {
    year: 'numeric',
    month: '2-digit'
  })
}

function formatDateWithoutTime (date, locale = 'de-DE') {
  if (typeof date === 'string') {
    date = Date.parse(date)
  }

  return new Date(date).toLocaleString(locale, {
    year: 'numeric',
    month: 'long',
    day: '2-digit',
    timeZone: 'CET'
  })
}

function formatHoursAndMinutes (date, locale = 'de-DE') {
  if (typeof date === 'string') {
    date = Date.parse(date)
  }

  return new Date(date).toLocaleString(locale, {
    hour: 'numeric',
    minute: 'numeric',
    timeZone: 'CET'
  })
}

function formatNumber (value) {
  return new Intl.NumberFormat('de-DE', { maximumSignificantDigits: 21 }).format(value)
}

function imageUri (that, path) {
  if (path) {
    const imagesBaseUrl = that.$config.imagesBaseUrl
    return `${imagesBaseUrl}/${path}`
  } else {
    return undefined
  }
}

function formatCurrency (value) {
  if (value !== undefined && value !== null) {
    const formatter = new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 0
    })
    return formatter.format(value)
  } else {
    return '- €'
  }
}

function maybeFormatCurrency (value, condition) {
  if (condition) {
    return formatCurrency(value)
  } else {
    return '... €'
  }
}

function formatInteger (value) {
  const formatter = new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 0
  })
  return formatter.format(value).slice(0, -2)
}

function lessThan30SecondsUntilThen (now, then) {
  if (then && now) {
    const secondsLeft = Math.ceil((then - now) / 1000)
    return secondsLeft <= 30
  }
  return false
}

async function addRedirectActionAndLogin (that, prompt, route) {
  try {
    if (route) {
      await api.addRedirectRouteAfterLoginActions(that, route)
    } else {
      await api.addDefaultAfterLoginRedirectActions(that)
    }
  } catch (e) {
    console.error('Error adding redirect action', e)
  }

  // const { locale } = that.$i18n

  await that.$router.push(that.localePath({ name: 'auth-login' }))

  // return that.$auth.loginWith('auth0',
  //   {
  //     params: {
  //       initialScreen: prompt,
  //       language: locale
  //     }
  //   }
  // )
}

async function addRedirectRouteAndSignUp (that, email, route) {
  try {
    await api.addRedirectRouteAfterLoginActions(that, route)
  } catch (e) {
    console.error('Error adding redirect action', e)
  }
  const { locale } = that.$i18n

  await that.$auth.loginWith('auth0',
    {
      params: {
        initialScreen: 'signUp',
        login_hint: email,
        language: locale
      }
    }
  )
}

function currentPriceColor (product) {
  if (
    product?.context?.hasFailedLateOfferOnProduct === true && product.context?.holdingHighestBid === true) {
    return 'error--text'
  }

  if (product.auction.status === 'acpt_late_offer') {
    return ''
  }

  if (product.context?.holdingHighestBid && ['recd_late_offer'].includes(product.auction.status)) {
    return 'tertiary--text'
  }

  if (product.context?.holdingHighestBid === true && ['failed'].includes(product.auction.status)) {
    return 'error--text'
  }

  if (product.context?.holdingHighestBid === false) {
    return 'error--text'
  } else if (product.context?.holdingHighestBid === true) {
    return 'success--text'
  } else {
    return ''
  }
}

function kwToPs (kw) {
  try {
    if (Number.isNaN(kw)) {
      kw = parseInt(kw)
    }
  } catch (e) {
  }

  const ps = kw * 1.35962
  return Number((ps).toFixed(0))
}

function showNetNotGross (merchant, merchantAddress) {
  return merchant?.vatRegNo?.length > 0 && merchantAddress?.country?.toLowerCase() !== 'deutschland'
}

function getSlugForAdInEditing (item, that) {
  function noDefectsExists (item) {
    return item?.attributes?.selects?.find(attribute => attribute.attributeCode === 'defects_exists')?.value?.label?.toLowerCase() === 'nein'
  }

  try {
    if (item.readyToSubmitForReview.attributeSets.product_images.requiredPercent >= 100) {
      return that.$t('links.slugs.auction')
    } else if (noDefectsExists(item) || item.readyToSubmitForReview.damages.requiredPercent >= 100) {
      return that.$t('links.slugs.images')
    } else if (item.readyToSubmitForReview.attributeSets.product_description.attributeGroups.product_description_general.requiredPercent >= 100) {
      return that.$t('links.slugs.defects')
    } else if (item.readyToSubmitForReview.attributeSets.product_equipment.requiredPercent >= 100) {
      return that.$t('links.slugs.images')
    } else if (item.readyToSubmitForReview.attributeSets.product_profile.requiredPercent >= 100) {
      return that.$t('links.slugs.equipment')
    } else {
      return that.$t('links.slugs.profile')
    }
  } catch (e) {
    console.error(e)
    return that.$t('links.slugs.profile')
  }
}

function getStepForAdInEditing (item, hasCompletedProfileData, isLoggedIn) {
  const isResubmitted = item.archivedAuctions && item.archivedAuctions?.length > 0
  try {
    let step = 'profile'
    if (item.readyToSubmitForReview.attributeSets.product_profile?.requiredPercent >= 100 ||
      item.readyToSubmitForReview.attributeSets.trailer_profile?.requiredPercent >= 100
    ) {
      step = 'equipment'

      if (item.readyToSubmitForReview.attributeSets.product_description.attributeGroups.product_description_general.requiredPercent >= 100) {
        step = 'defects'

        if (item.readyToSubmitForReview.attributeSets.product_description.attributeGroups.product_description_general.requiredPercent >= 100) {
          if (item.readyToSubmitForReview.damages.requiredPercent >= 100) {
            step = 'images'

            if (item.readyToSubmitForReview.attributeSets.product_images.requiredPercent >= 100) {
              step = 'auction'

              if (isResubmitted && hasCompletedProfileData && isLoggedIn) {
                return step
              }

              if (item.readyToSubmitForReview.attributeSets.auction.requiredPercent >= 100) {
                if (hasCompletedProfileData && isLoggedIn) {
                  step = 'last-step'
                } else {
                  step = 'personal-data'
                }
              }
            }
          }
        }
      }
    }

    return step
  } catch (e) {
    console.error(e)
    return 'profile'
  }
}

function getI18RouteParams (localizations, locale, slug) {
  const routeParams = {}
  localizations?.data.forEach((localization) => {
    routeParams[localization.attributes.locale] = {
      pathMatch: localization.attributes.url
    }
  })
  routeParams[locale] = {
    pathMatch: slug
  }

  return routeParams
}

function getPopulateSections () {
  return {
    'populate[sections][on][landing-page.hero-banner][populate][image][populate]':
      '*',
    'populate[sections][on][landing-page.hero-banner][populate][video][populate]':
      '*',
    'populate[sections][on][landing-page.hero-banner][populate][listItems][populate]':
      '*',
    'populate[sections][on][landing-page.hero-banner][populate][paddingBottom][populate]':
      '*',
    'populate[sections][on][landing-page.section-cta][populate]': '*',
    'populate[sections][on][landing-page.onboarding][populate]': '*',
    'populate[sections][on][landing-page.section-ad-intake-onboarding][populate]': '*',
    'populate[sections][on][landing-page.section-onb-vmm-motor][populate]': '*',
    'populate[sections][on][landing-page.section-onb-vmm-trailer][populate]': '*',
    'populate[sections][on][landing-page.section-onboarding-public-ad-intake]': '*',

    'populate[sections][on][landing-page.section-full-width-video-for-mobile][populate]': '*',

    'populate[sections][on][landing-page.known-from][populate][companies][populate]': '*',
    'populate[sections][on][landing-page.known-from][populate][paddingBottom][populate]': '*',

    'populate[sections][on][landing-page.landing-page-card][populate][image][populate]':
      '*',
    'populate[sections][on][landing-page.landing-page-card][populate][columnOne][populate]':
      '*',
    'populate[sections][on][landing-page.landing-page-card][populate][columnOneItems][populate]':
      '*',
    'populate[sections][on][landing-page.landing-page-card][populate][columnTwo][populate]':
      '*',
    'populate[sections][on][landing-page.landing-page-card][populate][columnTwoItems][populate]':
      '*',
    'populate[sections][on][landing-page.landing-page-card][populate][columnThree][populate]':
      '*',
    'populate[sections][on][landing-page.landing-page-card][populate][columnThreeItems][populate]':
      '*',
    'populate[sections][on][landing-page.landing-page-card][populate][columnFour][populate]':
      '*',
    'populate[sections][on][landing-page.landing-page-card][populate][columnFourItems][populate]':
      '*',
    'populate[sections][on][landing-page.landing-page-card][populate][paddingBottom][populate]':
      '*',

    'populate[sections][on][landing-page.reviews][populate]': '*',
    'populate[sections][on][landing-page.products][populate]': '*',
    'populate[sections][on][landing-page.stats][populate][stats][populate]': '*',
    'populate[sections][on][landing-page.stats][populate][image][populate]': '*',
    'populate[sections][on][landing-page.stats][populate][paddingBottom][populate]': '*',
    'populate[sections][on][landing-page.contacts][populate]': '*',
    'populate[sections][on][faq.faq-question-answer-section][populate]': '*',
    'populate[sections][on][landing-page.landing-divider][populate]': '*',
    'populate[sections][on][landing-page.landing-page-create-or-continue-ad-cta][populate]': '*',
    'populate[sections][on][landing-page.section-vertical-spacer][populate]': '*',
    'populate[sections][on][landing-page.section-ref-faq][populate]': '*',

    'populate[sections][on][landing-page.section-simple-listing][populate]': '*',

    'populate[sections][on][landing-page.section-full-width-video][populate]': '*'

  }
}

function getValuateMyVehicleParams () {
  return {
    'populate[listing][on][populate]': '*',
    'populate[listing][populate][items][populate]': '*',
    ...getPopulateSections()
  }
}

function getLandingPageParams (url) {
  return {
    'filters[url][$eq]': url,
    'populate[sections][on][landing-page.onboarding-into-ad-intake][populate]': '*',
    'populate[sections][on][landing-page.merchant-hero-banner][populate][image][populate]': '*',
    'populate[sections][on][landing-page.merchant-features][populate]': '*',
    'populate[sections][on][landing-page.merchant-faq][populate]': '*',
    ...getPopulateSections()
  }
}

function getArticlePageParams (url) {
  return {
    'filters[url][$eq]': url,

    'populate[author][on][populate]': '*',
    'populate[tags][on][populate]': '*',
    'populate[image][on][populate]': '*',
    'populate[author][populate][image][populate]': '*',

    'populate[blocks][on][article.rich-text][populate]': '*',
    'populate[blocks][on][article.image][populate][image][populate]': '*',
    'populate[blocks][on][article.video][populate]': '*',

    'populate[blocks][on][article.call-to-action][populate][goToLandingPage][populate]': 'url'

  }
}

class Cm24SnackbarType {
  static PRIVATE_COMPLETE_BUT_EMAIL_NOT_VERIFIED = 'PRIVATE_COMPLETE_BUT_EMAIL_NOT_VERIFIED'
  static PRIVATE_COMPLETE_AND_EMAIL_VERIFIED = 'PRIVATE_COMPLETE_AND_EMAIL_VERIFIED'
  static COMMERCIAL_COMPLETE_BUT_EMAIL_NOT_VERIFIED = 'COMMERCIAL_COMPLETE_BUT_EMAIL_NOT_VERIFIED'
  static COMMERCIAL_COMPLETE_AND_EMAIL_VERIFIED = 'COMMERCIAL_COMPLETE_AND_EMAIL_VERIFIED'

  static MERCHANT_COMPLETE_BUT_EMAIL_NOT_VERIFIED = 'MERCHANT_COMPLETE_BUT_EMAIL_NOT_VERIFIED'
  static MERCHANT_COMPLETE_AND_EMAIL_VERIFIED = 'MERCHANT_COMPLETE_AND_EMAIL_VERIFIED'

  static IMPORT_FROM_MOBILE_DE_FAILED = 'IMPORT_FROM_MOBILE_DE_FAILED'

  static IMPORT_FROM_SYSCARA_FAILED = 'IMPORT_FROM_SYSCARA_FAILED'
}

function debounce (fn, ms = 0) {
  let timeout

  return function (...args) {
    clearTimeout(timeout)

    timeout = setTimeout(fn.bind(this, ...args), ms)
  }
}

function getI18Domain (baseUrl, ending = 'de') {
  return baseUrl.replace(/\.[^.]*$/, '.' + ending)
}

function removeDomainEnding (baseUrl) {
  return baseUrl.replace(/\.[^.]*$/, '')
}

const makeBlacklist = [
  'airstream',
  'alpha',
  'caro',
  'caravelair',
  'chateau',
  'cristall',
  'domo',
  'esterel',
  'ffb - tabbert',
  'granduca',
  'heku',
  'hehn',
  'la marca',
  'mirage',
  'moncayo',
  'rmb',
  'riviera',
  'seitz',
  'selbstbau',
  'sprite',
  'sterckeman',
  't@b',
  'tabbert',
  'tischer',
  'wilk',

  'abi',
  'arca',
  'autostar',
  'avento',
  'azar4',
  'bawemo',
  'beyerland',
  'campster',
  'chrysler',
  'citroën',
  'coachmen',
  'dehler',
  'delta',
  'dopfer',
  'due erre',
  'evm',
  'euro liner',
  'extreme',
  'fr-mobil',
  'fiat',
  'fleetwood',
  'ford / reimo',
  'four-wheel camper',
  'general motors',
  'hrz',
  'holiday rambler',
  'home-car',
  'iveco',
  'kip',
  'm+m mobile',
  'man',
  'mazda',
  'mitsubishi',
  'monaco',
  'niewiadów',
  'nordstar',
  'opel',
  'ormocar',
  'paul &amp; paula',
  'paul & paula',
  'peugeot',
  'raclet',
  'reimo',
  'reisemobile beier',
  'renault',
  'riva',
  'roadtrek',
  'selbstausbau',
  'six-pac',
  'sloop',
  'tsl landsberg/ rockwood',
  'triple e',
  'vanster',
  'weippert',
  'winnebago',
  'woelcke']

const trailerMakeBlacklist = [
  'challenger',
  'chausson',
  'sun living'
]

function isMakeBlacklisted (make) {
  return makeBlacklist.includes(make.toLowerCase())
}

function isTrailerMakeBlacklisted (make) {
  return trailerMakeBlacklist.includes(make.toLowerCase())
}

function getPlannedDateOfSaleOptionForSubmitAdTracking (germanSelectOption, productType) {
  const prefix = 'submit_' + productType + '_'
  if (germanSelectOption?.label?.toLowerCase().includes('trans')) {
    return prefix + 'not_selling__updated_to__sell_now'
  } else if (germanSelectOption?.label?.toLowerCase().includes('sofort') || germanSelectOption?.label?.toLowerCase().includes('zeitnah')) {
    return prefix + 'sell_now'
  } else if (germanSelectOption?.label?.toLowerCase().includes('woche')) {
    return prefix + 'sell_in_weeks'
  } else if (germanSelectOption?.label?.toLowerCase().includes('monate')) {
    return prefix + 'sell_in_months'
  } else if (germanSelectOption?.label?.toLowerCase().includes('nicht') ||
    germanSelectOption?.label?.toLowerCase().includes('kein')
  ) {
    return prefix + 'not_selling'
  }
  return prefix + 'pdos_na'
}

function getPurposeOptionSubmitAdTracking (germanSelectOption, productType) {
  const prefix = 'submit_' + productType + '_'
  if (germanSelectOption?.label?.toLowerCase().includes('verkaufen')) {
    return prefix + 'purpose_selling'
  } else if (germanSelectOption?.label?.toLowerCase().includes('ermitteln')) {
    return prefix + 'purpose_valuation'
  }
  return prefix + 'pdos_na'
}

function getPlannedDateOfSaleOptionPrefixForTracking (germanSelectOption, productType) {
  const prefix = productType + '_'
  if (germanSelectOption?.label?.toLowerCase().includes('trans')) {
    return prefix + 'not_selling__updated_to__sell_now'
  } else if (germanSelectOption?.label?.toLowerCase().includes('sofort') || germanSelectOption?.label?.toLowerCase().includes('zeitnah')) {
    return prefix + 'sell_now'
  } else if (germanSelectOption?.label?.toLowerCase().includes('woche')) {
    return prefix + 'sell_in_weeks'
  } else if (germanSelectOption?.label?.toLowerCase().includes('monate')) {
    return prefix + 'sell_in_months'
  } else if (germanSelectOption?.label?.toLowerCase().includes('nicht') ||
    germanSelectOption?.label?.toLowerCase().includes('kein')
  ) {
    return prefix + 'not_selling'
  }
  return prefix + 'pdos_na'
}

function getPurposeOptionPrefixForTracking (germanSelectOption, productType) {
  const prefix = productType + '_'
  if (germanSelectOption?.label?.toLowerCase().includes('verkaufen')) {
    return prefix + 'purpose_selling'
  } else if (germanSelectOption?.label?.toLowerCase().includes('ermitteln')) {
    return prefix + 'purpose_valuation'
  }
  return prefix + 'pdos_na'
}

function newAdOrMyVehiclesRoute (hasAnyAds, isMerchant) {
  let routeName = hasAnyAds ? 'account-my-vehicles' : 'sell'
  if (isMerchant) {
    routeName = hasAnyAds > 0 ? 'account-merchant-ads' : 'sell'
  }
  return routeName
}

function labelIsX (label, regex) {
  if (label) {
    const test = regex.test(label.toLowerCase())
    if (test) {
      return true
    }
  }
  return false
}

function getAttributeSaveConfirmationSubtitle (attributeCode, that) {
  let subtitle = null

  const key = 'ad_intake.confirmation_popup.' + attributeCode.replace('trailer_', '')
  const value = that.$t(key)
  if (key !== value) {
    subtitle = value
  }
  return subtitle
}

function shouldShowAttributeSaveConfirmation (attributeCode, value) {
  if (!value) {
    return false
  }
  let show = false
  switch (attributeCode) {
    case 'mileage':
      if (value < 1000 || value > 999999) {
        show = true
      }

      break

    // HU abgelaufen: Ja
    // Raucherfahrzeug: ja
    // Partikelfilter nachgerüstet: Ja
    case 'smokers_car':
    case 'trailer_smokers_car':
    case 'upgrade_particulate_filter':
      if (labelIsX(value.label, /ja|yes/i)) {
        show = true
      }
      break

    case 'four_wheel_drive':
    case 'air_condition_independent':
    case 'trailer_winterproof':
    case 'winterproof':
      if (value === true) {
        show = true
      }
      break

    // Unfallstatus: Unbekannt
    // Wasserschaden: unbekannt
    // Hagelschaden: unbekannt
    case 'damaged':
    case 'trailer_damaged':
    case 'water_damaged':
    case 'trailer_water_damaged':
    case 'hail_damaged':
    case 'trailer_hail_damaged':
      if (labelIsX(value.label, /unbekannt|unknown|onbekend/i)) {
        show = true
      }
      break
    case 'fuel':
      if (labelIsX(value.label, /benzin|gasoline|bensin|benzine|gasolina|benzyna/i)) {
        show = true
      }
      break
    // Anzahl Fahrzeugschlüssel: 1
    case 'keys_car':
      if (labelIsX(value.label, /1/i)) {
        show = true
      }
      break

    case 'headlamps':
      // console.log(value)

      value.forEach((v) => {
        if (labelIsX(v?.label, /voll-led|xenon/i)) {
          show = true
        }
      })

      break
    case 'defects_exists':
    case 'hu_expired':
    case 'trailer_hu_expired':
      if (labelIsX(value.label, /nein|no|nee/i)) {
        show = true
      }
      break

    case 'yearly_leak_test':
      if (labelIsX(value.label, /jährlich\sdurchgeführt|carried out annually|jaarlijks uitgevoerd/i)) {
        show = true
      }
      break

    case 'trailer_leak_test_yearly':
      if (labelIsX(value.label, /ja|yes/i)) {
        show = true
      }
      break

    case 'service_and_inspection':
      if (labelIsX(value.label, /^serviceheftgepflegt$|^service book maintained$|^serviceboekje bijgehouden$/i)) {
        show = true
      }
      break

    default:
  }
  return show
}

const excludedPhoneCountries = [
  ['Afghanistan', 'AF'],
  ['Albania', 'AL'],
  ['Algeria', 'DZ'],
  ['American Samoa', 'AS'],
  // 'Andorra', 'AD'],
  ['Angola', 'AO'],
  ['Anguilla', 'AI'],
  ['Antarctica', 'AQ'],
  ['Antigua and Barbuda', 'AG'],
  ['Argentina', 'AR'],
  ['Armenia', 'AM'],
  ['Aruba', 'AW'],
  ['Australia', 'AU'],
  // 'Austria', 'AT'],
  ['Azerbaijan', 'AZ'],
  ['Bahamas (the)', 'BS'],
  ['Bahrain', 'BH'],
  ['Bangladesh', 'BD'],
  ['Barbados', 'BB'],
  ['Belarus', 'BY'],
  // 'Belgium', 'BE'],
  ['Belize', 'BZ'],
  ['Benin', 'BJ'],
  ['Bermuda', 'BM'],
  ['Bhutan', 'BT'],
  ['Bolivia (Plurinational State of)', 'BO'],
  ['Bonaire', 'BQ'],
  ['Bosnia and Herzegovina', 'BA'],
  ['Botswana', 'BW'],
  ['Bouvet Island', 'BV'],
  ['Brazil', 'BR'],
  ['British Indian Ocean Territory (the)', 'IO'],
  ['Brunei Darussalam', 'BN'],
  // 'Bulgaria', 'BG'],
  ['Burkina Faso', 'BF'],
  ['Burundi', 'BI'],
  ['Cabo Verde', 'CV'],
  ['Cambodia', 'KH'],
  ['Cameroon', 'CM'],
  ['Canada', 'CA'],
  ['Cayman Islands (the)', 'KY'],
  ['Central African Republic (the)', 'CF'],
  ['Chad', 'TD'],
  ['Chile', 'CL'],
  ['China', 'CN'],
  ['Christmas Island', 'CX'],
  ['Cocos (Keeling) Islands (the)', 'CC'],
  ['Colombia', 'CO'],
  ['Comoros (the)', 'KM'],
  ['Congo (the Democratic Republic of the)', 'CD'],
  ['Congo (the)', 'CG'],
  ['Cook Islands (the)', 'CK'],
  ['Costa Rica', 'CR'],
  // ['Croatia', 'HR'],
  ['Cuba', 'CU'],
  ['Curaçao', 'CW'],
  ['Cyprus', 'CY'],
  // ['Czechia', 'CZ'],
  ['Côte Ivoire', 'CI'],
  // 'Denmark', 'DK'],
  ['Djibouti', 'DJ'],
  ['Dominica', 'DM'],
  ['Dominican Republic (the)', 'DO'],
  ['Ecuador', 'EC'],
  ['Egypt', 'EG'],
  ['El Salvador', 'SV'],
  ['Equatorial Guinea', 'GQ'],
  ['Eritrea', 'ER'],
  // 'Estonia', 'EE'],
  ['Eswatini', 'SZ'],
  ['Ethiopia', 'ET'],
  ['Falkland Islands (the) [Malvinas]', 'FK'],
  ['Faroe Islands (the)', 'FO'],
  ['Fiji', 'FJ'],
  // 'Finland', 'FI'],
  // 'France', 'FR'],
  ['French Guiana', 'GF'],
  ['French Polynesia', 'PF'],
  ['French Southern Territories (the)', 'TF'],
  ['Gabon', 'GA'],
  ['Gambia (the)', 'GM'],
  ['Georgia', 'GE'],
  // 'Germany', 'DE'],
  ['Ghana', 'GH'],
  ['Gibraltar', 'GI'],
  // 'Greece', 'GR'],
  ['Greenland', 'GL'],
  ['Grenada', 'GD'],
  ['Guadeloupe', 'GP'],
  ['Guam', 'GU'],
  ['Guatemala', 'GT'],
  ['Guernsey', 'GG'],
  ['Guinea', 'GN'],
  ['Guinea-Bissau', 'GW'],
  ['Guyana', 'GY'],
  ['Haiti', 'HT'],
  ['Heard Island and McDonald Islands', 'HM'],
  ['Holy See (the)', 'VA'],
  ['Honduras', 'HN'],
  ['Hong Kong', 'HK'],
  //  'Hungary', 'HU'],
  ['Iceland', 'IS'],
  ['India', 'IN'],
  ['Indonesia', 'ID'],
  ['Iran (Islamic Republic of)', 'IR'],
  ['Iraq', 'IQ'],
  ['Ireland', 'IE'],
  ['Isle of Man', 'IM'],
  ['Israel', 'IL'],
  // 'Italy', 'IT'],
  ['Jamaica', 'JM'],
  ['Japan', 'JP'],
  ['Jersey', 'JE'],
  ['Jordan', 'JO'],
  ['Kazakhstan', 'KZ'],
  ['Kenya', 'KE'],
  ['Kiribati', 'KI'],
  ['Korea', 'KP'],
  ['Korea (the Republic of)', 'KR'],
  ['Kuwait', 'KW'],
  ['Kyrgyzstan', 'KG'],
  ['Lao People', 'LA'],
  //  'Latvia', 'LV'],
  ['Lebanon', 'LB'],
  ['Lesotho', 'LS'],
  ['Liberia', 'LR'],
  ['Libya', 'LY'],
  // 'Liechtenstein', 'LI'],
  // ['Lithuania', 'LT'],
  // 'Luxembourg', 'LU'],
  ['Macao', 'MO'],
  ['Madagascar', 'MG'],
  ['Malawi', 'MW'],
  ['Malaysia', 'MY'],
  ['Maldives', 'MV'],
  ['Mali', 'ML'],
  ['Malta', 'MT'],
  ['Marshall Islands (the)', 'MH'],
  ['Martinique', 'MQ'],
  ['Mauritania', 'MR'],
  ['Mauritius', 'MU'],
  ['Mayotte', 'YT'],
  ['Mexico', 'MX'],
  ['Micronesia (Federated States of)', 'FM'],
  ['Moldova (the Republic of)', 'MD'],
  ['Monaco', 'MC'],
  ['Mongolia', 'MN'],
  ['Montenegro', 'ME'],
  ['Montserrat', 'MS'],
  ['Morocco', 'MA'],
  ['Mozambique', 'MZ'],
  ['Myanmar', 'MM'],
  ['Namibia', 'NA'],
  ['Nauru', 'NR'],
  ['Nepal', 'NP'],
  // 'Netherlands (the)', 'NL'],
  ['New Caledonia', 'NC'],
  ['New Zealand', 'NZ'],
  ['Nicaragua', 'NI'],
  ['Niger (the)', 'NE'],
  ['Nigeria', 'NG'],
  ['Niue', 'NU'],
  ['Norfolk Island', 'NF'],
  ['Northern Mariana Islands (the)', 'MP'],
  //  'Norway', 'NO'],
  ['Oman', 'OM'],
  ['Pakistan', 'PK'],
  ['Palau', 'PW'],
  ['Palestine', 'PS'],
  ['Panama', 'PA'],
  ['Papua New Guinea', 'PG'],
  ['Paraguay', 'PY'],
  ['Peru', 'PE'],
  ['Philippines (the)', 'PH'],
  ['Pitcairn', 'PN'],
  // 'Poland', 'PL'],
  // 'Portugal', 'PT'],
  ['Puerto Rico', 'PR'],
  ['Qatar', 'QA'],
  ['Republic of North Macedonia', 'MK'],
  // 'Romania', 'RO'],
  ['Russian Federation (the)', 'RU'],
  ['Rwanda', 'RW'],
  ['Réunion', 'RE'],
  ['Saint Barthélemy', 'BL'],
  ['Saint Helena', 'SH'],
  ['Saint Kitts and Nevis', 'KN'],
  ['Saint Lucia', 'LC'],
  ['Saint Martin (French part)', 'MF'],
  ['Saint Pierre and Miquelon', 'PM'],
  ['Saint Vincent and the Grenadines', 'VC'],
  ['Samoa', 'WS'],
  ['San Marino', 'SM'],
  ['Sao Tome and Principe', 'ST'],
  ['Saudi Arabia', 'SA'],
  ['Senegal', 'SN'],
  ['Serbia', 'RS'],
  ['Seychelles', 'SC'],
  ['Sierra Leone', 'SL'],
  ['Singapore', 'SG'],
  ['Sint Maarten (Dutch part)', 'SX'],
  // 'Slovakia', 'SK'],
  // 'Slovenia', 'SI'],
  ['Solomon Islands', 'SB'],
  ['Somalia', 'SO'],
  ['South Africa', 'ZA'],
  ['South Georgia and the South Sandwich Islands', 'GS'],
  ['South Sudan', 'SS'],
  // 'Spain', 'ES'],
  ['Sri Lanka', 'LK'],
  ['Sudan (the)', 'SD'],
  ['Suriname', 'SR'],
  ['Svalbard and Jan Mayen', 'SJ'],
  // 'Sweden', 'SE'],
  // 'Switzerland', 'CH'],
  ['Syrian Arab Republic', 'SY'],
  ['Taiwan (Province of China)', 'TW'],
  ['Tajikistan', 'TJ'],
  ['Tanzania', 'TZ'],
  ['Thailand', 'TH'],
  ['Timor-Leste', 'TL'],
  ['Togo', 'TG'],
  ['Tokelau', 'TK'],
  ['Tonga', 'TO'],
  ['Trinidad and Tobago', 'TT'],
  ['Tunisia', 'TN'],
  ['Turkey', 'TR'],
  ['Turkmenistan', 'TM'],
  ['Turks and Caicos Islands (the)', 'TC'],
  ['Tuvalu', 'TV'],
  ['Uganda', 'UG'],
  ['Ukraine', 'UA'],
  ['United Arab Emirates (the)', 'AE'],
  ['United Kingdom of Great Britain and Northern Ireland (the)', 'GB'],
  ['United States Minor Outlying Islands (the)', 'UM'],
  ['United States of America (the)', 'US'],
  ['Uruguay', 'UY'],
  ['Uzbekistan', 'UZ'],
  ['Vanuatu', 'VU'],
  ['Venezuela (Bolivarian Republic of)', 'VE'],
  ['Viet Nam', 'VN'],
  ['Virgin Islands (British)', 'VG'],
  ['Virgin Islands (U.S.)', 'VI'],
  ['Wallis and Futuna', 'WF'],
  ['Western Sahara', 'EH'],
  ['Yemen', 'YE'],
  ['Zambia', 'ZM'],
  ['Zimbabwe', 'ZW'],
  ['Åland Islands', 'AX']
]

function getButtonSize (that) {
  const size = { xs: 'large' }[that.$vuetify.breakpoint.name]
  return size ? { [size]: true } : {}
}

function sanitizeFilename (filename, fallbackExtension = 'jpg') {
  // Generate a random 4-letter alphabetic suffix
  const randomSuffix = Array.from({ length: 4 }, () =>
    String.fromCharCode(65 + Math.floor(Math.random() * 26))
  ).join('')

  const name = filename || ''
  const lastDot = name.lastIndexOf('.')
  const basename = lastDot === -1 ? name : name.substring(0, lastDot)
  const ext = lastDot === -1 ? '' : name.substring(lastDot + 1)

  // Replace anything not a-z, A-Z, 0-9 or . with _
  const sanitizedBase = (basename
    .replace(/[^a-zA-Z0-9.]/g, '_')
    .replace(/\s+/g, '_')) || 'image'

  // Android pickers regularly hand us names without an extension ("image", or a
  // name derived from a content:// URI). Without this the key ends in a bare dot,
  // which S3 accepts but ImageKit will never serve.
  const sanitizedExt = (ext.replace(/[^a-zA-Z0-9]/g, '') || fallbackExtension).toLowerCase()

  return `${sanitizedBase}_${randomSuffix}.${sanitizedExt}`
}

/**
 * Re-wrap a Blob/File under a new name without touching its contents.
 * Falls back to tagging the Blob where the File constructor is unavailable.
 */
function renameFile (file, newName) {
  try {
    return new File([file], newName, {
      type: file.type,
      lastModified: file.lastModified || Date.now()
    })
  } catch (e) {
    file.name = newName
    return file
  }
}

/**
 * True when a request never received a response at all: the browser reported a
 * transport failure (axios surfaces XHR's `error` event as "Network Error") or
 * the request timed out. Both are transient by nature.
 *
 * A 4xx/5xx is *not* one of these — it is a real answer from the server and
 * replaying it would either fail identically or duplicate a side effect, so
 * only response-less failures are retryable.
 *
 * Matches a raw axios error as well as the SerializableAxiosError that
 * plugins/axios.js rejects with, which flattens `response` to null.
 */
function isTransportError (error) {
  return Boolean(error) &&
    !error.response &&
    Boolean(error.isAxiosError || error.name === 'SerializableAxiosError')
}

/**
 * Run an axios request, retrying only response-less failures with backoff.
 *
 * `send` must build and issue the request on every call — reusing a single
 * promise would just re-await the same failure. Anything that is not a
 * transport error is rethrown immediately. onRetry is called once per genuine
 * retry, before the delay.
 *
 * Only safe for requests that are free of side effects; see the call sites.
 */
async function requestWithRetry (
  send,
  {
    attempts = 3,
    backoffMs = 250,
    onRetry = null
  } = {}
) {
  for (let i = 1; i <= attempts; i++) {
    try {
      return await send()
    } catch (error) {
      if (i === attempts || !isTransportError(error)) {
        throw error
      }

      if (onRetry) {
        onRetry({
          attempt: i + 1,
          attempts,
          message: error.message
        })
      }

      // Same shape as putToS3WithRetry: 250ms, 1s, 2.25s, ... plus jitter.
      const delay = backoffMs * i * i + Math.floor(Math.random() * 250)
      // eslint-disable-next-line promise/param-names
      await new Promise(r => setTimeout(r, delay))
    }
  }
}

/**
 * PUT a body to a pre-signed S3 URL, with a timeout and retries.
 *
 * fetch() *rejects* ("TypeError: Failed to fetch") on network-level failures —
 * a mobile connectivity blip, a CORS/preflight problem, an in-browser blocker —
 * and it never times out on its own, so a stalled upload would otherwise hang
 * forever. It also resolves normally for 4xx/5xx, hence the explicit res.ok
 * check. onRetry is called only for genuine retries (attempt > 1).
 */
async function putToS3WithRetry (
  {
    url,
    body,
    headers = {}
  },
  {
    attempts = 3,
    timeoutMs = 60000,
    backoffMs = 250,
    onRetry = null
  } = {}
) {
  let lastErr
  for (let i = 1; i <= attempts; i++) {
    const controller = new AbortController()
    const timeout = setTimeout(() => controller.abort(), timeoutMs)

    try {
      // Only report actual retries — capturing every first attempt drowned the
      // signal we need to diagnose upload failures.
      if (i > 1 && onRetry) {
        onRetry({
          attempt: i,
          url,
          headers
        })
      }

      const res = await fetch(url, {
        method: 'PUT',
        headers,
        body,
        credentials: 'omit', // explicit equivalent to withCredentials: false
        signal: controller.signal
      })

      clearTimeout(timeout)

      if (!res.ok) {
        throw new Error(`S3 PUT failed with status ${res.status}`)
      }

      return
    } catch (err) {
      clearTimeout(timeout)
      lastErr = err

      console.error('[upload] PUT error (attempt ' + i + '):', err)

      if (i < attempts) {
        // Exponential backoff with jitter: 250ms, 1s, 2.25s, ...
        const delay = backoffMs * i * i + Math.floor(Math.random() * 250)
        // eslint-disable-next-line promise/param-names
        await new Promise(r => setTimeout(r, delay))
      }
    }
  }

  throw new Error(`S3 PUT failed after ${attempts} attempt(s)`, { cause: lastErr })
}

const delays = [500, 1000, 2000, 5000, 10000, 15000, 20000] // in ms
async function waitForImageInImageKit (that, url, maxTries = delays.length) {
  const imageUrl = that.$config.imageKitBaseURL + '/' + url
  let lastError = null

  for (let i = 0; i < maxTries; i++) {
    try {
      // no-store: a negative response cached by the browser would otherwise keep
      // returning 404 for the rest of the polling window.
      const res = await fetch(imageUrl, {
        method: 'HEAD',
        cache: 'no-store'
      })

      if (res.ok) {
        return true
      }

      lastError = new Error(`ImageKit responded ${res.status} for ${url}`)
    } catch (e) {
      // fetch() *rejects* on network-level failures (offline blip, CORS, in-browser
      // ad/tracker blocking) rather than resolving with ok === false. Swallow it and
      // keep polling — aborting here marked already-uploaded images as failed.
      lastError = e
    }

    if (i < maxTries - 1) {
      const delay = delays[Math.min(i, delays.length - 1)]
      await new Promise(resolve => setTimeout(resolve, delay))
    }
  }

  throw new Error(`Image not available after upload: ${url}`, { cause: lastError })
}

async function readBlobSlice (blob, bytes) {
  const slice = blob.slice(0, bytes)

  if (slice.arrayBuffer) {
    return await slice.arrayBuffer()
  }

  return await new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(reader.result)
    reader.onerror = () => reject(reader.error)
    reader.readAsArrayBuffer(slice)
  })
}

/**
 * Read the intrinsic pixel dimensions straight out of the JPEG/PNG header,
 * without decoding the image. Decoding a 50MP photo is precisely the step we are
 * trying to avoid, so the size guard has to be established before it happens.
 *
 * Returns null when the format isn't recognised — callers must handle that.
 */
async function readImageDimensions (file) {
  try {
    // EXIF blocks sit between the SOI and the frame header, so give the marker
    // walk enough room to reach SOFn even with an embedded thumbnail.
    const head = new DataView(await readBlobSlice(file, 262144))

    // PNG: 8-byte signature, then the IHDR chunk carries width/height at 16/20.
    if (
      head.byteLength >= 24 &&
      head.getUint32(0) === 0x89504E47 &&
      head.getUint32(4) === 0x0D0A1A0A
    ) {
      return {
        width: head.getUint32(16),
        height: head.getUint32(20)
      }
    }

    // JPEG: walk the marker chain until a start-of-frame segment.
    if (head.byteLength >= 4 && head.getUint16(0) === 0xFFD8) {
      let offset = 2

      while (offset + 9 < head.byteLength) {
        if (head.getUint8(offset) !== 0xFF) {
          offset++
          continue
        }

        const marker = head.getUint8(offset + 1)

        // Padding and standalone markers carry no length field.
        if (marker === 0xFF || marker === 0x01 || (marker >= 0xD0 && marker <= 0xD9)) {
          offset += 2
          continue
        }

        const length = head.getUint16(offset + 2)
        if (length < 2) {
          break
        }

        // SOF0-SOF15, excluding DHT (C4), JPGA (C8) and DAC (CC).
        if (marker >= 0xC0 && marker <= 0xCF && marker !== 0xC4 && marker !== 0xC8 && marker !== 0xCC) {
          return {
            height: head.getUint16(offset + 5),
            width: head.getUint16(offset + 7)
          }
        }

        offset += 2 + length
      }
    }
  } catch (e) {
    console.warn('[upload] Could not read image dimensions from header', e)
  }

  return null
}

/**
 * Build createImageBitmap options that decode the source *directly* at a reduced
 * size, so a full-resolution bitmap is never allocated. A 50MP photo decodes to
 * roughly 200MB of RGBA, which is what pushes mobile browsers over the edge.
 *
 * Only resizeWidth is set: the browser derives the height and so preserves the
 * aspect ratio regardless of how EXIF orientation reshapes the decoded image.
 */
function buildDecodeOptions (dimensions, maxWidth, maxHeight) {
  const options = { imageOrientation: 'from-image' }

  if (!dimensions || !dimensions.width || !dimensions.height) {
    return options
  }

  const maxEdge = Math.max(maxWidth, maxHeight)
  const sourceEdge = Math.max(dimensions.width, dimensions.height)
  const scale = Math.min(maxEdge / sourceEdge, 1)

  if (scale >= 1) {
    return options
  }

  // Clamping to the smaller source edge keeps an EXIF-rotated image from being
  // decoded *larger* than it started.
  options.resizeWidth = Math.max(1, Math.min(
    Math.round(dimensions.width * scale),
    dimensions.width,
    dimensions.height
  ))
  options.resizeQuality = 'high'

  return options
}

async function compressImageWithCanvas (
  file,
  maxWidth = 1600,
  maxHeight = 1200,
  quality = 0.8,
  { background = '#ffffff' } = {} // fill for transparent PNGs
) {
  // toBlob polyfill (no-op on modern browsers)
  if (!HTMLCanvasElement.prototype.toBlob) {
    HTMLCanvasElement.prototype.toBlob = function (callback, type, quality) {
      const dataURL = this.toDataURL(type, quality)
      const bin = atob(dataURL.split(',')[1])
      const len = bin.length
      const arr = new Uint8Array(len)
      for (let i = 0; i < len; i++) {
        arr[i] = bin.charCodeAt(i)
      }
      callback(new Blob([arr], { type: type || 'image/png' }))
    }
  }

  let objUrl = null
  let source // HTMLImageElement or ImageBitmap
  try {
    // Fast path: ImageBitmap with EXIF-aware orientation when supported.
    // The File is already a Blob — the previous createObjectURL + fetch round-trip
    // just materialised a second full copy of it in memory.
    if (window.createImageBitmap) {
      const dimensions = await readImageDimensions(file)
      const decodeOptions = buildDecodeOptions(dimensions, maxWidth, maxHeight)

      try {
        source = await createImageBitmap(file, decodeOptions)
      } catch (e) {
        // Browsers that reject the options bag lose EXIF orientation, but keep the
        // resize hint if we can — it is what stops the decode from OOMing.
        try {
          source = await createImageBitmap(file, {
            resizeWidth: decodeOptions.resizeWidth,
            resizeQuality: decodeOptions.resizeQuality
          })
        } catch (e1) {
          source = await createImageBitmap(file)
        }
      }
    } else {
      // Fallback: <img>. Browsers apply EXIF orientation to <img> by default.
      objUrl = URL.createObjectURL(file)
      const img = new Image()
      img.src = objUrl
      await img.decode() // modern; fallback to onload if needed
      source = img
    }

    const iw = source.width
    const ih = source.height

    const scale = Math.min(maxWidth / iw, maxHeight / ih, 1)
    const tw = Math.max(1, Math.round(iw * scale))
    const th = Math.max(1, Math.round(ih * scale))

    const canvas = document.createElement('canvas')
    canvas.width = tw
    canvas.height = th

    const ctx = canvas.getContext('2d', { alpha: false }) // opaque target
    ctx.imageSmoothingEnabled = true
    ctx.imageSmoothingQuality = 'high'

    // Replace alpha with a solid background for PNG/WebP with transparency
    ctx.fillStyle = background
    ctx.fillRect(0, 0, tw, th)

    ctx.drawImage(source, 0, 0, tw, th)

    // eslint-disable-next-line promise/param-names
    const blob = await new Promise(res => canvas.toBlob(res, 'image/jpeg', quality))
    if (!blob) {
      throw new Error('Canvas toBlob produced null')
    }

    const newName = /\.[^./]+$/.test(file.name)
      ? file.name.replace(/\.[^./]+$/, '.jpg')
      : `${file.name || 'image'}.jpg`

    return renameFile(blob, newName)
  } finally {
    // Release the decoded bitmap on *every* path. Previously this only ran on
    // success, so a toBlob failure leaked a full-resolution bitmap right before
    // the retry allocated another one.
    if (typeof ImageBitmap !== 'undefined' && source instanceof ImageBitmap && source.close) {
      source.close()
    }
    if (objUrl) {
      URL.revokeObjectURL(objUrl)
    }
  }
}

// Compressing to 1600x1200 @ q0.8 lands around 300-600 KB, so anything already
// below this would gain nothing from the round-trip.
const compressionSizeThreshold = 1024 * 1024 // 1 MB

/**
 * Files small enough to upload as-is skip compression entirely. Decoding is the
 * expensive, crash-prone step on mobile browsers, so the cheapest fix is not to
 * do it at all when there is nothing to gain. Only file.size is consulted here —
 * it needs no decode.
 */
function needsCompression (file, sizeThreshold = compressionSizeThreshold) {
  if (!file || typeof file.size !== 'number') {
    return true
  }

  // Unknown/exotic types (Android pickers often report an empty type) still go
  // through the canvas so they end up as a JPEG the backend can serve.
  if (!/^image\/(jpeg|png)$/.test(file.type)) {
    return true
  }

  return file.size > sizeThreshold
}

// Progressively smaller targets. Each rung also shrinks the decode budget, so a
// device that runs out of memory decoding for rung 1 gets a genuine second (and
// third) chance rather than retrying at the same cost. The previous retry asked
// for 2000x1500 — larger than the first attempt, so it could only ever fail too.
const compressionLadder = [
  {
    maxWidth: 1600,
    maxHeight: 1200,
    quality: 0.8
  },
  {
    maxWidth: 1280,
    maxHeight: 960,
    quality: 0.75
  },
  {
    maxWidth: 1024,
    maxHeight: 768,
    quality: 0.7
  },
  {
    maxWidth: 640,
    maxHeight: 480,
    quality: 0.6
  }
]

async function compressImage (file, options = {}) {
  const {
    sizeThreshold = compressionSizeThreshold,
    ladder = compressionLadder
  } = options

  if (!needsCompression(file, sizeThreshold)) {
    console.log('[upload] skipping compression', file.name, file.type, file.size, 'bytes')
    return file
  }

  for (let i = 0; i < ladder.length; i++) {
    const rung = ladder[i]

    try {
      const compressed = await compressImageWithCanvas(
        file,
        rung.maxWidth,
        rung.maxHeight,
        rung.quality
      )

      console.log('[upload] compressed',
        file.name,
        `${file.size} bytes =>`,
        `${compressed.size} bytes`,
        `at ${rung.maxWidth}x${rung.maxHeight} q${rung.quality}`
      )

      return compressed
    } catch (e) {
      console.error(
        `[upload] Compression failed for ${file.name} at ${rung.maxWidth}x${rung.maxHeight}`,
        e
      )
    }
  }

  // Every rung failed. Uploading the original is still better than dropping the
  // image, even though it is large.
  console.error('[upload] All compression attempts failed, returning original file ' + file.name)

  return file
}

/**
 * Compress multiple image files (e.g. from input.files)
 */
async function compressImages (files, options = {}) {
  const results = []

  for (const file of files) {
    const compressed = await compressImage(file, options)
    results.push(compressed)
  }

  return results
}

async function hashIdentifier (input, type = 'email') {
  if (!process.client) {
    // running on server (SSR) → don’t hash, return null or handle differently
    return null
  }

  if (!input) {
    return null
  }

  let normalized
  if (type === 'email') {
    normalized = input.trim().toLowerCase()
  } else if (type === 'phone') {
    normalized = input.replace(/\D+/g, '')
  } else {
    throw new Error('Invalid type: must be \'email\' or \'phone\'')
  }

  const encoder = new TextEncoder()
  const data = encoder.encode(normalized)
  const hashBuffer = await crypto.subtle.digest('SHA-256', data)

  return Array.from(new Uint8Array(hashBuffer))
    .map(b => b.toString(16).padStart(2, '0'))
    .join('')
}

function parseEntityId (pathOrUrl) {
  // Works with full URLs or just paths starting with "/"
  const url = new URL(pathOrUrl, 'https://dummy.base')
  const m = url.pathname.match(/\/(\d+)(?:\/|$)/)
  return m ? Number(m[1]) : null // or return m?.[1] if you prefer a string
}

// Two concurrent inits would fetch two different uuids and the ad created under the
// first would be lost when the second cookie wins; share the running request instead.
let inflightCm24UuidInit = null

async function initCm24UuidFromClientSide (that) {
  // console.log('initCm24UuidFromClientSide')
  const cm24Uuid = that.$cookies.get('cm24-uuid')
  if (cm24Uuid) {
    // console.log('cm24-uuid already exists:', cm24Uuid)
    return
  }

  if (inflightCm24UuidInit) {
    await inflightCm24UuidInit
    return
  }

  const domain = location.hostname.replace('www', '')
    .replace('.staging', '')
  const query = that.$route.query
  const $axios = that.$axios
  const $cookies = that.$cookies
  inflightCm24UuidInit = that.$store.dispatch('initCm24Uuid', {
    query,
    $axios,
    $cookies,
    domain
  })
  try {
    await inflightCm24UuidInit
  } finally {
    inflightCm24UuidInit = null
  }
}

function getPercentageDifference (a, b) {
  if (a === 0 || b === 0) {
    return 0
  }
  return parseInt(-((a - b) / b) * 100)
}

/**
 * Safe localStorage access.
 * Merely touching window.localStorage throws a SecurityError when the browser
 * denies storage access (blocked site data, some private modes, embedded
 * contexts), and setItem throws QuotaExceededError when storage is full.
 * Returns null / false instead of throwing so callers can render regardless.
 */
function safeLocalStorageGet (key) {
  if (typeof window === 'undefined') {
    return null
  }
  try {
    return window.localStorage.getItem(key)
  } catch (e) {
    return null
  }
}

function safeLocalStorageSet (key, value) {
  if (typeof window === 'undefined') {
    return false
  }
  try {
    window.localStorage.setItem(key, value)
    return true
  } catch (e) {
    return false
  }
}

export default {
  normalizePhone,
  formatDate,
  formatDateLong,
  formatDateShort,
  formatDateMini,
  formatDateWithoutTime,
  formatDateWithoutTimeShort,
  formatHoursAndMinutes,
  imageUri,
  formatCurrency,
  formatInteger,
  lessThan30SecondsUntilThen,
  formatNumber,
  addRedirectActionAndLogin,
  Cm24SnackbarType,
  currentPriceColor,
  maybeFormatCurrency,
  kwToPs,
  showNetNotGross,
  formatDateMonthYear,
  addRedirectRouteAndSignUp,
  debounce,
  getSlugForAdInEditing,
  formatDateAvailabilty,
  getStepForAdInEditing,
  getI18RouteParams,
  getPopulateSections,
  getLandingPageParams,
  getI18Domain,
  removeDomainEnding,
  getArticlePageParams,
  isMakeBlacklisted,
  getValuateMyVehicleParams,
  getPlannedDateOfSaleOptionForSubmitAdTracking,
  isTrailerMakeBlacklisted,
  newAdOrMyVehiclesRoute,
  excludedPhoneCountries,
  shouldShowAttributeSaveConfirmation,
  getAttributeSaveConfirmationSubtitle,
  formatDateWithSeconds,
  getButtonSize,
  getPlannedDateOfSaleOptionPrefixForTracking,
  sanitizeFilename,
  renameFile,
  needsCompression,
  readImageDimensions,
  putToS3WithRetry,
  requestWithRetry,
  isTransportError,
  waitForImageInImageKit,
  compressImage,
  compressImages,
  hashIdentifier,
  parseEntityId,
  labelIsX,
  compressImageWithCanvas,
  initCm24UuidFromClientSide,
  getPercentageDifference,
  getPurposeOptionSubmitAdTracking,
  getPurposeOptionPrefixForTracking,
  safeLocalStorageGet,
  safeLocalStorageSet
}
